export default "__VITE_ASSET__C$XqFryr__"